export const PRAISE_TAGS = [
  'Good pilot',
  'Good gunner',
  'Good medic',
  'Good engineer',
  'Great comms',
  'On time',
  'Fair pay',
  'Calm under fire',
  'Knows the ropes',
  'Would fly again',
];
